import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-background-light dark:bg-background-dark py-8 text-center border-t border-[#f4ebe7] dark:border-white/5">
            <p className="text-sm text-[#1c120d]/60 dark:text-white/60">
                © 2024 Merajut Asa Kita. All rights reserved. <br />
                Kampung Binong Jati, Bandung.
            </p>
        </footer>
    );
};

export default Footer;
